import axiosApi from '../../kits/axiosApi';

// initial state
const state = {};

// getters
const getters = {};

// actions
function persistLogin(commit, data) {
    commit('app/APP_SET_GLOBAL_DATA', data, { root: true });
    window.localStorage.setItem('chain_id', data.chain_id);
    window.localStorage.setItem('chain_name', data.chain_name);
    window.localStorage.setItem('token', data.token);
    window.localStorage.setItem('user_name', data.user_name);
    window.localStorage.setItem('role', data.role);
    window.localStorage.setItem('cluster', data.cluster);
}

const actions = {
    apply_session({ commit }, data) {
        persistLogin(commit, data);
    },
    do_login_aj({ commit, rootState }, post_data) {
        let aj_host = rootState.aj_host;
        return axiosApi
            .get(aj_host + '/weapp/master/user/login', {
                params: {
                    user_id: post_data.user_id,
                    pswd: post_data.pswd
                }
            })
            .then((res) => {
                if (res.data.data.code == 100000) {
                    persistLogin(commit, res.data.data.data);
                    post_data.router.replace({ path: '/insight/home' });
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }
};

// mutations
const mutations = {};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
